import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import { UnstyledLink } from "../UnstyledLink";
import FocusHandler from "../handler/FocusHandler";
var defaultProps = {
  color: 'blue',
  type: 'button'
};
export var InlineLink = /*#__PURE__*/React.forwardRef(function InlineLink(props, ref) {
  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? defaultProps.color : _props$color,
      disabled = props.disabled,
      _props$type = props.type,
      type = _props$type === void 0 ? defaultProps.type : _props$type,
      remaining = _objectWithoutProperties(props, ["children", "className", "color", "disabled", "type"]);

  var classes = classNames('InlineLink', "Text-color--".concat(color), className, {
    'Is--disabled': disabled
  });
  return /*#__PURE__*/React.createElement(FocusHandler, null, function (inputMethodProps, inputMethod) {
    return (
      /*#__PURE__*/
      // $FlowFixMe - go/flowfixme122
      React.createElement(UnstyledLink, _extends({}, inputMethodProps, remaining, {
        className: classes,
        disabled: disabled,
        ref: ref,
        type: type,
        "data-input-method": inputMethod
      }), children)
    );
  });
}); // $FlowFixMe this is just for the default value fields in the docs

InlineLink.defaultProps = defaultProps;